<template>
  <SectionCard
    :title="getTitle"
    data-aos="fade-in"
    class="news-card"
  >
    <div
      v-for="(item, index) in newsList"
      :key="index"
      class="carditem"
    >
      <a
        :href="item.href"
        target="_blank"
      >
        <a-card hoverable>
          <div class="imgstyle">
            <img
              :src="item.imgSrc"
              alt="picture"
              width="100%"
            >
          </div>
          <a-card-meta
            class="content-wrapper"
          >
            <template slot="description">
              <a
                :href="item.href"
                target="_blank"
              >{{ item.title }}</a>
            </template>
          </a-card-meta>
        </a-card>
      </a>
    </div>

    <!-- <div class="btndiv">
      <myButton customType="link" href="#">查看全部</myButton>
    </div> -->
  </SectionCard>
</template>

<script>
export default {
  components: {
    SectionCard: () => import("@/components/SectionCard.vue")
    // myButton: () => import("@/components/MyButton.vue")
  },
  computed: {
    newsList () {
      const value = [
        {
          imgSrc: require("../assets/news/media_6.webp"),
          title: this.$t("media.t6"),
          href:"https://lambdanetwork.medium.com/lambda-data-availability-lda-technical-solution-design-031eed6e724d"
        },
        {
          imgSrc: require("../assets/news/media_1.webp"),
          title: this.$t("media.t1"),
          href:"https://lambdanetwork.medium.com/genify-the-first-generative-nft-brand-in-of-lambda-ecosystem-has-officially-launched-9954e8fd05d1"
        },
        {
          imgSrc: require("../assets/news/media_2.webp"),
          title: this.$t("media.t2"),
          href:"https://medium.com/@lambdanetwork/the-lambda-spark-upgrade-empower-web3-with-better-storage-4f72b0166d2a"
        },
        {
          imgSrc: require("../assets/news/media_3.webp"),
          title: this.$t("media.t3"),
          href:
            "https://medium.com/@lambdanetwork/lns-the-first-web3-generated-art-domain-service-launched-f7081ea68926"
        },
        {
          imgSrc: require("../assets/news/media_4.webp"),
          title: this.$t("media.t4"),
          href:
            "https://medium.com/@lambdanetwork/lambda-web3-service-how-it-works-1d68e25d83b5"
        },
        {
          imgSrc: require("../assets/news/media_5.webp"),
          title: this.$t("media.t5"),
          href:
            "https://medium.com/@lambdanetwork/decentralized-storage-network-lambda-and-conflux-reach-strategic-cooperation-to-jointly-develop-e3adc2b6a4a8"
        }
       
      ];
      return value;
    },
    getTitle () {
      return this.$t("media.title");
    }
  }
};
</script>
<style lang="less" scoped>
.btndiv {
  width: 100%;
  text-align: center;
  margin-top: 46px;
  margin-bottom: 40px;
}

.imgstyle {
  width: 100%;
  img {
    max-width: 100%;
    height: 230px!important;  
    object-fit: fill;  
  }
}
.content-wrapper {
  padding-top: 20px;
}
.news-card {
  margin-bottom: 60px;
}
@media (max-width: 2500px) {
  .carditem {
    width: 30%;
    margin-bottom: 20px;

    .ant-card {
      // height: 316px;
      // width: 316px;

      text-align: left;
    }
  }

  .carditem:nth-child(3n) {
    .ant-card {
      float: right;
    }
  }
  .carditem:nth-child(3n-1) {
    margin-right: 5%;
    text-align: center;
    .ant-card {
      margin: auto;
    }
  }
  .carditem:nth-child(3n-2) {
    margin-right: 5%;
    .ant-card {
      float: left;
    }
  }
}

@media (max-width: 992px) {
  .carditem {
    width: 48%;
  }
  .carditem:nth-child(3n) {
    margin: 0;
    .ant-card {
      float: right;
    }
  }
  .carditem:nth-child(3n-1) {
    margin: 0;
    text-align: center;
    .ant-card {
      margin: auto;
    }
  }
  .carditem:nth-child(3n-2) {
    margin: 0;
    .ant-card {
      float: left;
    }
  }
  .carditem:nth-child(2n) {
    text-align: center;
    margin-left: 4%;
    margin-bottom: 22px;
    .ant-card {
      float: right;
    }
  }
  .carditem:nth-child(2n-1) {
    text-align: center;
    margin-bottom: 22px;
    .ant-card {
      float: left;
    }
  }
}

@media (max-width: 500px) {
  .carditem {
    width: 100%;

    .ant-card {
      margin: 0 auto;
      float: none;
    }
  }
  .carditem:nth-child(3n) {
    text-align: center;
    margin: auto;
    margin-bottom: 22px;
    .ant-card {
      margin: 0 auto;
      float: none;
    }
  }
  .carditem:nth-child(3n-1) {
    text-align: center;
    margin: auto;
    margin-bottom: 22px;
    .ant-card {
      margin: 0 auto;
      float: none;
    }
  }
  .carditem:nth-child(3n-2) {
    text-align: center;

    margin: auto;
    margin-bottom: 22px;
    .ant-card {
      margin: 0 auto;
      float: none;
    }
  }
}
</style>
